import { ReactElement, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { useWindowSize } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import { MD_WIDTH } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import HomeStack from '~/ui/pages/Home/common/HomeStack';
import { sitewideDiscount } from '~/constants/siteConfig';
import { CoreContext } from '@Hotels-at-Home/hah-fe-core/dist/context';
import { useRouter } from 'next/router';

import { computedWithDiscount, computePrices } from '@Hotels-at-Home/hah-fe-core/dist/utils';
import { getPrices } from '@Hotels-at-Home/hah-fe-core/dist/utils/price';

const staticPrices = [
  // Bed category
  {
    maxRegular: 995,
    minRegular: 995,
    discount: sitewideDiscount,
    isPercentage: true,
  },
];

const BedSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bedSection' });
  const { t: tLink } = useTranslation('', {
    keyPrefix: '$local.$homePageLinks.$bedSection',
  });

  const router = useRouter();
  const {
    data: { currency, promotion },
  } = useContext(CoreContext);
  const prices = computedWithDiscount(staticPrices, promotion?.promo_is_active);
  const staticPrice = computePrices(prices)[0];

  const currentCurrency = currency;
  const price = getPrices(staticPrice[currentCurrency], router.locale);

  const windowSize = useWindowSize();
  const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;

  return (
    <section className="hp-section bed-section" id="hp-bed">
      <div className="bed-section-container">
        <HomeStack
          title={t('heading')}
          description={t('description')}
          img="/images/homePage/bedSection/pullman-bed.webp"
          imgMobile="/images/homePage/bedSection/pullman-bed-mob.webp"
          url={tLink('bed')}
          loading="eager"
        />
      </div>
    </section>
  );
};

export default BedSection;
